import { Injectable } from '@angular/core';
import { BalanceService, CurrencyType, microableCurrency } from '@app/core/balance.service';
import { CryptoPipe } from '@app/shared/pipes/crypto.pipe';
import { AuthenticationService } from '@app/core';
import { PlayerService } from '@app/player.service';

@Injectable()
export class HelpersService {
  constructor(
    private balanceService: BalanceService,
    private authService: AuthenticationService,
    private playerService: PlayerService,
    private cryptoPipe: CryptoPipe
  ) {}

  public toBetResult(amount: number, currency?: CurrencyType | string): string {
    if (!currency) {
      currency = this.playerService.getCurrency();
    }
    return `${this.cryptoPipe.transform(amount, currency, 'symbol', true, true)} ${this.getCurrencyLabel(currency)}`;
  }

  public getCurrencyLabel(currency?: CurrencyType | string): string {
    if (!currency) {
      currency = this.playerService.getCurrency();
    }
    if (microableCurrency(<CurrencyType>currency)) {
      return (this.balanceService.getMicroViewer() ? 'm' : '') + currency.toString().toUpperCase();
    }
    return currency.toString().toUpperCase();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/services/helpers.service.ts